var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('router-link',{attrs:{"to":("/courses/" + (_vm.golfCourse.uuid))}},[_vm._v(_vm._s(_vm.golfCourse.name))])],1),_c('td',[_vm._v(_vm._s(_vm.golfCourse.full_address))])])}
var staticRenderFns = []

export { render, staticRenderFns }